import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'

import Home from '../views/Home.vue'
import Login from "@/components/Login";
import Trance from "../views/Trance";
import Reports from  '../views/Reports'
import NewBill from '../views/NewBill'
import ClientTrance from  '../views/ClientTrance'
import TranceShow from '../views/TranceShow'
import TranceShowTablet from '../views/TranceShowTablet'
import ServiceResults from "../views/ServiceResults";
import Payments from "../views/Payments";
import RepCards from "../views/RepCards";
import Service from "../views/Service";
import Limits from "../views/limits";
import HistoryLimits from "../views/HistoryLimits"
import HistoryLimitsStatus from '../views/HistoryLimitsStatus'
import HistoryLimitsHolder from '../views/HistoryLimitsHolder'
import DigitalWallets from '../views/DigitalWallets'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
      breadcrumb: 'Головна'
    },
    children: [
      {
        path: 'digital-wallets',
        name: 'DigitalWallets',
        component: DigitalWallets,
        meta: {
          requiresAuth: true,
          breadcrumb: 'Електроний гаманець'
        },
      },
      {
        path: 'limits',
        name: 'Limits',
        component: Limits,
        meta: {
          requiresAuth: true,
          breadcrumb: 'Стан лімітів'
        },
        children: [
          {
            path: ':number_cart/history',
            name: "HistoryLimits",
            component: HistoryLimits,
            meta: {
              requiresAuth: true,
              breadcrumb: 'Історія змін по картці'
            }
          },
          {
            path: ':number_cart/status',
            name: "HistoryLimitsStatus",
            component: HistoryLimitsStatus,
            meta: {
              requiresAuth: true,
              breadcrumb: 'Історія змін статусу'
            }
          },
          {
            path: ':number_cart/holder',
            name: "HistoryLimitsHolder",
            component: HistoryLimitsHolder,
            meta: {
              requiresAuth: true,
              breadcrumb: 'Історія змін тримача'
            }
          }
        ]
      },
      {
        path: 'service-results',
        name: 'ServiceResults',
        component: ServiceResults,
        meta: {
          requiresAuth: true,
          breadcrumb: 'Підсумки обслуговування'
        }
      },
      {
        path: 'payments',
        name: 'Payments',
        component: Payments,
        meta: {
          requiresAuth: true,
          breadcrumb: 'Оплата'
        }
      },
      {
        path: 'rep_cards',
        name: 'RepCards',
        component: RepCards,
        meta: {
          requiresAuth: true,
          breadcrumb: 'Поповнення карток'
        }
      },
      {
        path: 'service',
        name: 'Service',
        component: Service,
        meta: {
          requiresAuth: true,
          breadcrumb: 'Обслуговування'
        }
      },
      {
        path: 'reports',
        name: 'Reports',
        component: Reports,
        children: [
          {
            path: 'bills',
            name: "NewBill",
            components: NewBill,
          },
          {
            path: 'cbills',
          },
          {
            path: 'client-trance',
            name: 'ClientTrance',
            component: ClientTrance,
          },
        ],
        meta: {
          requiresAuth: true,
          breadcrumb: 'Підсумки обслуговування'
        }
      },
      {
        path: 'trance',
        name: 'Trance',
        component: Trance,
        meta: {
          requiresAuth: true,
          breadcrumb: 'Транзакції'
        }
      },
    ]
  },
  {
    path: '/trance-show',
    name: 'TranceShow',
    component: TranceShow,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/trance-show-tablet',
    name: 'TranceShowTablet',
    component: TranceShowTablet,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})
export default router
